import { Anchor, Breadcrumbs } from "@mantine/core";
import React from "react";
import "../header/header.css";

import { useAppSelector } from "../../redux/hooks";
import { useNavigate } from "react-router-dom";

function HccBreadCrumb() {
  const crumbs = useAppSelector((state) => state.breadcrumb.breadCrumbs);
  const navigate = useNavigate();

  return (
    <div className="w-full  ">
      <Breadcrumbs
        className="px-6  sm:px-8 py-7 mx-auto max-w-[1600px] "
        separatorMargin="md"
        separator=">"
      >
        {crumbs.map((cr: any, index: number) =>
          index === crumbs.length - 1 ? (
            <Anchor
              key={index}
              onClick={(e) => {
                e.preventDefault();
                navigate(cr.route);
              }}
            >
              <a
                href={cr.route}
                className="font-semibold text-base text-breadCrumbGray no-underline"
              >
                {cr.name}
              </a>
            </Anchor>
          ) : (
            <Anchor
              onClick={(e) => {
                e.preventDefault();
                navigate(cr.route);
              }}
              key={index}
            >
              <a
                href={cr.route}
                className="font-normal text-base text-breadCrumbGray no-underline"
              >
                {cr.name}
              </a>
            </Anchor>
          )
        )}
      </Breadcrumbs>
      <div className="separatorBar " />
    </div>
  );
}

export default HccBreadCrumb;
